import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

const EmblemDivider = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });

  return (
    <div className="emblem-divider" ref={ref}>
      <motion.img
        src="https://customer-assets.emergentagent.com/job_390cde5b-422d-4c41-b8a2-9021ac6fe4b8/artifacts/o4ewfjxj_IPMI-50th-Emblem.png"
        alt="IPMI 50th Anniversary"
        className="emblem-image"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={isInView ? { opacity: 1, scale: 1 } : {}}
        transition={{ duration: 0.8, ease: "easeOut" }}
      />
    </div>
  );
};

export default EmblemDivider;
